import {Component, Input, OnInit} from '@angular/core';
import {ContentService} from '../../services/content.service';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
//import * as scrollIntoView from 'scroll-into-view';



declare var jquery: any;
declare var $: any;
declare var scrollIntoView: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [ContentService]
})
export class HeaderComponent implements OnInit {

  @Input() data: any;

  constructor(private _contentService: ContentService,
              private route: ActivatedRoute, private router: Router
              ) {

    const promise = new Promise((resolve, reject) => {
      setTimeout(() => {
        const opts = {
          mode: 'horizontal',
          minSlides: 1,
          slideMargin: 0,
          ticker: true,
          speed: 9000,
          autoDirection: 'next',
          sliderHeigth: 1000
        };
        $('.sliders').bxSlider(opts);
      }, 1000);
    });
  }

  ngOnInit() {
  }

  onAnchorClick() {
    const x = document.querySelector('#contenido');
    if (x) {
      //x.scrollIntoView({behavior: 'smooth'});
      x.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
    /*const target = document.getElementById('contenido');
    scrollIntoView(target, {
      time: 1000,
      align:{
        top: 0,
        left: 0.5
      },
      ease: function(value){
        return 1 - Math.pow(1 - value, value / 5);
      }
    }, function(type){
      target.textContent = type;
    });*/
    // adjust these two to match your HTML hierarchy


  }

}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts